import React from 'react'
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import NavigationPanelReorderGroup from "../reorder-group/reorder-group";
import Navigation_Separator from "../../buttons/separator";

type Props = {

    onDragEnd           : callback
}

export default function NavigationPanel_PinnedViews({onDragEnd}: Props) {

    const views = _.filter(gd.navigationStructure.views, (section: NavigationSection) => {
        return !section.isInMore
    })

    if (views.length === 0) return null

    return (
        <>
            <NavigationPanelReorderGroup sections={views} onDragEnd={onDragEnd}/>

            <Navigation_Separator/>
        </>
    )
}